var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colored-notes",class:{ 'colored-notes--indent': _vm.indent },style:(_vm.cssProps)},[_c('div',{staticClass:"colored-notes__text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2),_c('div',{staticClass:"colored-notes__border",style:({ backgroundColor: _vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }